module.exports = __webpack_public_path__ + "img/2.07.01a241d1.jpg";